/*
  eslint
  react/no-array-index-key: off,
  react/no-string-refs: off,
  react/default-props-match-prop-types: off,
  react/no-find-dom-node: off,
  no-mixed-operators: off
*/

import React, { PropTypes, Component } from 'react';
import ReactDOM from 'react-dom';

import classNames from 'classnames';

import { countryList } from './country_data';

import styles from './styles.scss';

const modernBrowser = Boolean(document.createElement('input').setSelectionRange);
const keys = {
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  LEFT: 37,
  SPACE: 32,
  ENTER: 13,
  PLUS: 43,
  ESC: 27,
  A: 65,
  Z: 90,
};


function isNumberValid(num) {
  return countryList.some(c => num.indexOf(c.dialCode) === 0);
}


function filterOnly(onlyCountries) {
  if (onlyCountries.length === 0) {
    return countryList;
  }
  return countryList.filter(c => onlyCountries.indexOf(c.iso2) !== -1);
}


function filterExcluded(selected, excluded) {
  if (excluded.length === 0) {
    return selected;
  }
  return selected.filter(c => excluded.indexOf(c.iso2) !== -1);
}


class ReactPhoneInput extends Component {
  constructor(props) {
    super(props);
    const { value, excludeCountries } = props;

    const onlyCountries = filterExcluded(filterOnly(props.onlyCountries), excludeCountries);
    const selectedCountry = this.selectCountry(value, onlyCountries);
    const highlightCountryIndex = countryList.findIndex(c => c === selectedCountry);
    const formattedNumber = this.formatNumber(value, selectedCountry.format);
    const preferredCountries =
      props.preferredCountries.map(pc => countryList.find(c => c.iso2 === pc));


    this.getHighlightCountryIndex = this.getHighlightCountryIndex.bind(this);
    this.handleDropdownClick = this.handleDropdownClick.bind(this);
    this.renderDropdown = this.renderDropdown.bind(this);
    this.selectCountry = this.selectCountry.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
    this.handleInputClick = this.handleInputClick.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.searchCountry = this.searchCountry.bind(this);
    this.formatNumber = this.formatNumber.bind(this);
    this.cursorToEnd = this.cursorToEnd.bind(this);
    this.getElement = this.getElement.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
    this.search = this.search.bind(this);

    this.state = {
      preferredCountries,
      selectedCountry,
      onlyCountries,
      highlightCountryIndex,
      formattedNumber,
      queryString: '',
      showDropDown: false,
      hasCountry: false,
      edited: false,
      valid: true,
    };
  }


  componentDidMount() {
    document.addEventListener('keydown', this.handleKeydown);
  }


  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  }


  getElement(index) {
    return ReactDOM.findDOMNode(this.refs[`flag_no_${index}`]);
  }


  getHighlightCountryIndex(direction) {
    const { onlyCountries, preferredCountries } = this.state;

    const highlightCountryIndex = this.state.highlightCountryIndex + direction;

    if (
      highlightCountryIndex < 0 ||
      highlightCountryIndex >= (onlyCountries.length + preferredCountries.length)
    ) {
      return highlightCountryIndex - direction;
    }

    return highlightCountryIndex;
  }


  handleInputKeyDown(event) {
    if (event.which === keys.ENTER) {
      this.props.onEnterKeyPress(event);
    }

    if (this.props.onKeyDown) {
      this.props.onKeyDown(event);
    }
  }


  handleKeydown(event) {
    if (!this.state.showDropDown) {
      return;
    }

    function moveHighlight(direction) {
      this.setState({
        highlightCountryIndex: this.getHighlightCountryIndex(direction),
      }, () => {
        this.scrollTo(this.getElement(this.state.highlightCountryIndex), true);
      });
    }

    switch (event.which) {
      case keys.DOWN:
        moveHighlight(1);
        break;
      case keys.UP:
        moveHighlight(-1);
        break;
      case keys.ENTER:
        this.handleItemClick(this.state.onlyCountries[this.state.highlightCountryIndex], event);
        break;
      case keys.ESC:
        this.setState({ showDropDown: false }, this.cursorToEnd);
        break;
      default:
        if ((event.which >= keys.A && event.which <= keys.Z) || event.which === keys.SPACE) {
          this.setState({
            queryString: this.state.queryString + String.fromCharCode(event.which),
          });
        }
    }
  }


  searchCountry() {
    const { queryString, onlyCountries, preferredCountries } = this.state;

    const probableCandidate = this.search(queryString) || onlyCountries[0];
    const probableCandidateIndex =
      onlyCountries.findIndex(c => c === probableCandidate) + preferredCountries.length;

    this.scrollTo(this.getElement(probableCandidateIndex), true);

    this.setState({
      queryString: '',
      highlightCountryIndex: probableCandidateIndex,
    });
  }


  handleInputFocus(e) {
    if (ReactDOM.findDOMNode(this.refs.numberInput).value === '+') {
      this.setState(
        { formattedNumber: `+${this.state.selectedCountry.dialCode}` },
        () => setTimeout(this.cursorToEnd, 10),
      );
    }

    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  }


  handleItemClick(country) {
    const { selectedCountry, onlyCountries, formattedNumber } = this.state;

    const nextSelectedCountry = onlyCountries.find(c => c === country);

    if (selectedCountry.iso2 !== nextSelectedCountry.iso2) {
      const newNumber = formattedNumber.replace(
        selectedCountry.dialCode,
        nextSelectedCountry.dialCode,
      );

      const newFormattedNumber = this.formatNumber(newNumber, nextSelectedCountry.format);

      this.setState({
        selectedCountry: nextSelectedCountry,
        formattedNumber: newFormattedNumber,
        hasCountry: true,
        showDropDown: false,
      }, () => {
        this.cursorToEnd();
        if (this.props.onChange) {
          const val = {
            phone: newFormattedNumber,
            country: nextSelectedCountry.name,
            code: nextSelectedCountry.dialCode,
          };
          this.props.onChange(val);
        }
      });
    }
  }


  handleInputClick(evt) {
    this.setState({ showDropDown: false });
    if (this.props.onClick) {
      this.props.onClick(evt);
    }
  }


  handleInput(event) {
    let { selectedCountry, hasCountry, formattedNumber } = this.state;
    const { onlyCountries } = this.state;
    const { value } = event.target;

    if (value === formattedNumber) {
      return;
    }

    const input = value.replace(/\D/g, '');

    if (input.length > 16) {
      return;
    }

    if (value.length > 0) {
      if (!hasCountry || selectedCountry.dialCode.length > input.length) {
        selectedCountry = this.selectCountry(input, onlyCountries);
        hasCountry = false;
      }

      formattedNumber = this.formatNumber(input, selectedCountry.format);
    }

    let valid = false;
    if (formattedNumber && formattedNumber.length > 1) {
      valid = true;
    }

    if (this.props.onValidation) {
      this.props.onValidation(valid);
    }
    if (this.props.onChange) {
      const val = {
        phone: formattedNumber,
        country: selectedCountry.name,
        code: selectedCountry.dialCode,
      };
      this.props.onChange(val);
    }

    this.setState({
      formattedNumber, hasCountry, selectedCountry, valid, edited: true,
    });
  }


  handleDropdownClick() {
    const { showDropDown, onlyCountries, selectedCountry } = this.state;

    const newState = {
      highlightCountryIndex: onlyCountries.findIndex(c => c === selectedCountry),
      highlightCountry: onlyCountries.find(c => c === selectedCountry),
      showDropDown: !showDropDown,
    };

    this.setState(newState);
  }


  cursorToEnd() {
    const input = ReactDOM.findDOMNode(this.refs.numberInput);
    input.focus();
    if (modernBrowser) {
      const len = input.value.length;
      input.setSelectionRange(len, len);
    }
  }


  formatNumber(text, pattern) {
    const number = text.replace(/\D/g, '');
    if (!number || number.length === 0) return '+';
    if (
      !this.props.autoFormat ||
      number.length < 2 ||
      !pattern
    ) return `+${number}`;

    const numberArray = number.split('');
    const formattedNumber = pattern.split('').map((i) => {
      if (!numberArray.length) return '';
      if (i === '.') return numberArray.shift();
      return i;
    });

    return formattedNumber.join('');
  }


  scrollTo(country, middle) {
    if (!country) return;

    const container = ReactDOM.findDOMNode(this.refs.flagDropdownList);

    if (!container) return;

    const containerHeight = container.offsetHeight;
    const containerOffset = container.getBoundingClientRect();
    const containerTop = containerOffset.top + document.body.scrollTop;
    const containerBottom = containerTop + containerHeight;

    const el = country;
    const elOffset = el.getBoundingClientRect();

    const elHeight = el.offsetHeight;
    const elTop = elOffset.top + document.body.scrollTop;
    const elBottom = elTop + elHeight;
    const middleOffset = (containerHeight / 2) - (elHeight / 2);

    let newScrollTop = elTop - containerTop + container.scrollTop;
    if (elTop < containerTop) {
      if (middle) { // scroll up
        newScrollTop -= middleOffset;
      }
      container.scrollTop = newScrollTop;
    } else if (elBottom > containerBottom) {
      if (middle) { // scroll down
        newScrollTop += middleOffset;
      }
      container.scrollTop = newScrollTop - (containerHeight - elHeight);
    }
  }


  selectCountry(text, countries) {
    const number = text.replace(/\D/g, '');

    const { defaultCountry } = this.props;

    const backup = countryList.find(c => c.iso2 === defaultCountry) || countries[0];

    if (number.trim() === '') {
      return backup;
    }

    const guess = countries.find(c => number.indexOf(c.dialCode) === 0);

    if (!guess) {
      return backup;
    }

    return guess;
  }


  search(q) {
    if (!q || q.length === 0) {
      return null;
    }

    const { onlyCountries } = this.state;
    const probables =
      onlyCountries.filter(c => c.name.toLowerCase().indexOf(q.toLowerCase()) === 0);

    return probables[0];
  }


  renderDropdown() {
    const { preferredCountries, onlyCountries, highlightCountryIndex } = this.state;

    const countries = preferredCountries.concat(onlyCountries);
    const dropDowns = countries.map((i, k) => {
      const itemClasses = classNames({
        country: true,
        preferred: i.iso2 === 'us' || i.iso2 === 'gb',
        active: i.iso2 === 'us',
        highlight: highlightCountryIndex === k,
      });

      const flagClasses = `flag ${i.iso2}`;

      return (
        <li
          data-flag-key={`flag_no_${k}`}
          ref={`flag_no_${k}`}
          key={`flag_no_${k}`}
          className={itemClasses}
          data-dial-code="1"
          data-country-code={i.iso2}
          onClick={() => this.handleItemClick(i)}
        >
          <div className={flagClasses} />
          <span className='CountryName'>{i.name}</span>
          <span className='dial-code'>{`+${i.dialCode}`}</span>
        </li>
      );
    });

    const dashedLi = (<li key="dashes" className='divider' />);
    // let's insert a dashed line in between preffered countries and the rest
    dropDowns.splice(this.state.preferredCountries.length, 0, dashedLi);

    const dropDownClasses = classNames({
      'country-list': true,
      hide: !this.state.showDropDown,
    });

    return (
      <ul ref="flagDropdownList" className={dropDownClasses}>
        {dropDowns}
      </ul>
    );
  }


  render() {
    const {
      valid, edited, showError, selectedCountry, showDropDown,
    } = this.state;
    const { error } = this.props;
    const inputClasses = classNames({
      'form-control': true,
      'invalid-number': !valid && edited && showError,
    });

    const flagViewClasses = classNames({
      'flag-dropdown': true,
      'open-dropdown': this.state.showDropDown,
    });

    const inputFlagClasses = `flag ${selectedCountry.iso2}`;

    let dropdown;
    if (showDropDown) {
      dropdown = this.renderDropdown();
    }

    let errorMessage;
    if (!valid && edited && showError) {
      errorMessage = error;
    }

    return (
      <div className={styles.Phone}>
        <input
          onChange={this.handleInput}
          onClick={this.handleInputClick}
          onFocus={this.handleInputFocus}
          onKeyDown={this.handleInputKeyDown}
          value={this.state.formattedNumber}
          onBlur={() => this.setState({ showError: true })}
          ref="numberInput"
          type="tel"
          className={inputClasses}
        />
        <div ref="flagDropDownButton" className={flagViewClasses} onKeyDown={this.handleKeydown}>
          <div
            ref="selectedFlag"
            onClick={this.handleDropdownClick}
            className='selected-flag'
            title={`${selectedCountry.name}: + ${selectedCountry.dialCode}`}
          >
            <div className={inputFlagClasses} />
          </div>

          {dropdown}
        </div>

        <div className={styles.Error}>{errorMessage || ' '}</div>
      </div>
    );
  }
}


ReactPhoneInput.defaultProps = {
  value: '',
  autoFormat: true,
  onlyCountries: [],
  excludeCountries: [],
  defaultCountry: countryList[0].iso2,
  isValid: isNumberValid,
  flagsImagePath: './flags.png',
  onEnterKeyPress: () => {},
};


ReactPhoneInput.propTypes = {
  value: PropTypes.string,
  error: PropTypes.string,
  autoFormat: PropTypes.bool,
  defaultCountry: PropTypes.string,
  onlyCountries: PropTypes.arrayOf(PropTypes.string),
  excludeCountries: PropTypes.arrayOf(PropTypes.string),
  preferredCountries: PropTypes.arrayOf(PropTypes.string),
  onEnterKeyPress: PropTypes.func,
  onValidation: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
};


export default ReactPhoneInput;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/phone/index.jsx